/* eslint-disable react/prop-types */
import React from "react"
import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride } from "@shared/primitive-components"
import { IFrame } from "./iframe"
import { usePolicyAndFleet } from "../contexts"

type Props = RouteComponentProps<{
  tripId: string
}>

export const Trip: React.FC<Props> = ({ tripId }) => {
  const { policy } = usePolicyAndFleet()

  return (
    <>
      <DocumentTitleOverride>Flock Motor | Trip Details</DocumentTitleOverride>
      <IFrame path={`policies/${policy.id}/trip/${tripId}`} />
    </>
  )
}
